export enum EmailStatus {
    Pending = 0,
    Sent = 1,
    Failed = 2
}
